import React from "react";
import { useTranslation } from "react-i18next";

import articleDeliveryTypes from "astrid-firestore/src/api/articles/constants/articleDeliveryTypes";

import Form from "../../../forms/components/Form/Form";

import useDeliveryTypeTranslations from "../../hooks/useDeliveryTypeTranslations";

export default function DeliveryTypesSelect({ name, disabled = false }) {
	const { t } = useTranslation();

	const deliveryTypeTranslations = useDeliveryTypeTranslations();

	return (
		<Form.Select
			label={t("deliveryTypes", "Delivery types")}
			multiple
			name={name || "deliveryTypes"}
			disabled={disabled}
			options={Object.values(articleDeliveryTypes).map((deliveryType) => ({
				key: deliveryType,
				value: deliveryType,
				text: deliveryTypeTranslations[deliveryType],
			}))}
		/>
	);
}
